import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { config } from '../function/config'
import axios from 'axios'
import { toast } from 'react-toastify'
import { FaTimes, FaBars } from 'react-icons/fa'

export default function Login() {
    const navigate = useNavigate()

    const [menuOpen, setMenuOpen] = useState(false)

    const [formData, setFormData] = useState({
        username: '',
        password: ''
    })

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!formData.username.trim()) {
            toast.error('Please fill the username')
            return
        }

        if (!formData.password.trim()) {
            toast.error('Please fill the password')
            return
        }

        try {
            const res = await axios.post(`${config.baseurl}login/`, formData, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )

            console.log('Status:', res.status)
            console.log('Data:', res.data)

            if (res.status === 200) {
                localStorage.setItem('token', res.data.token)
                localStorage.setItem(
                    'user',
                    JSON.stringify(res.data.user)
                )

                toast.success('User Login Successfully')

                // Navigate based on role
                if (res.data.role === 'Staff') {
                    navigate('/staff/staff_dashboard')
                } 
                else if (res.data.role === 'Telecaller') {
                    navigate('/telecaller/telecaller_dashboard')
                } 
                else if (res.data.role === 'Manager') {
                    navigate('/manager/manager_dashboard')
                } 
                else if (res.data.role === 'Admin') {
                    navigate('/admin/admin_dashboard')
                } 
                else if (
                    res.data.role === 'Super Admin' ||
                    res.data.is_superuser
                ) {
                    navigate('/super_admin/super_admin_dashboard')
                } 
                else {
                    toast.error('User role not recognized')
                }
            } else {
                toast.error('Login Failed')
            }

        } catch (error) {
            console.error('Login Error:', error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to Login'

            toast.error(message)
        }
    }

    return (
        <div className="min-h-screen bg-white">

            {/* Header */}
            <header className="fixed top-0 left-0 right-0 bg-[#191c24] z-50 shadow-md">
                <div className="max-w-full mx-auto px-4 py-2 flex justify-between items-center">

                    {/* Logo + Name */}
                    <div className="flex items-center gap-3 text-white">

                        <img
                            src={require('../images/Logo.jpg')}
                            alt="Aurevia Charitable Trust Logo"
                            className="w-12 h-12 object-contain rounded"
                        />

                        <h1 className="text-xl font-bold 3xl:text-lg 2xl:text-base">
                            Aurevia Charitable Trust
                        </h1>

                    </div>

                    {/* Desktop Navigation */}
                    <nav className="flex 4xl:hidden gap-5 text-white items-center">

                        <Link
                            href="#home"
                            className="no-underline text-white"
                        >
                            Home
                        </Link>

                        <Link
                            href="#about-us"
                            className="no-underline text-white"
                        >
                            About Us
                        </Link>

                        <Link
                            href="#contact-us"
                            className="no-underline text-white"
                        >
                            Contact Us
                        </Link>

                        <Link
                            href="#our-programs"
                            className="no-underline text-white"
                        >
                            Our Programs
                        </Link>

                        <Link
                            to="/donation"
                            className="no-underline text-white"
                        >
                            Donate
                        </Link>

                        <Link
                            to="/login"
                            className="no-underline text-white"
                        >
                            Login
                        </Link>

                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        type="button"
                        className="hidden 4xl:flex text-2xl text-white"
                        onClick={() => setMenuOpen((prev) => !prev)}
                    >
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                </div>

                {/* Mobile Navigation */}
                {menuOpen && (
                    <div className="hidden 4xl:block absolute top-full right-0 w-64 bg-[#191c24] border-l border-slate-600 shadow-lg">

                        <nav className="flex flex-col py-3">

                            <Link
                                href="#home"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Home
                            </Link>

                            <Link
                                href="#about-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                About Us
                            </Link>

                            <Link
                                href="#contact-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Contact Us
                            </Link>

                            <Link
                                href="#our-programs"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Our Programs
                            </Link>

                            <Link
                                to="/donation"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Donate
                            </Link>

                            <Link
                                to="/login"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Login
                            </Link>
                        </nav>
                    </div>
                )}
            </header>


            {/* Login Section */}
            <main className="min-h-screen pt-20 flex items-center justify-center px-4 py-8">
                <section className="w-full max-w-5xl bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200">
                    <div className="grid grid-cols-2 4xl:grid-cols-1 min-h-[550px]">
                        {/* Left Side */}
                        <div className="relative min-h-[550px] 4xl:min-h-[350px]">
                            <img
                                src={require('../images/Login bg.jpg')}
                                alt="Login Background"
                                className="absolute inset-0 w-full h-full object-cover "
                            />

                            <div className="absolute inset-0 bg-[#191c24]/75"></div>

                            <div className="relative z-10 h-full flex flex-col justify-center items-center text-white text-center p-10 min-h-[550px] 4xl:min-h-[150px]">

                                <img
                                    src={require('../images/Logo.jpg')}
                                    alt="Logo"
                                    className="4xl:w-10 4xl:h-10 w-24 h-24 object-contain rounded-full mb-6"
                                />

                                <h2 className="4xl:text-lg text-3xl font-serif font-bold mb-4">
                                    Welcome to
                                    <br />
                                    Aurevia Charitable Trust
                                </h2>

                                <p className="4xl:text-xs text-xl font-semibold mb-3">
                                    Access Your Account Securely
                                </p>

                            </div>

                        </div>


                        {/* Right Side - Login Form */}
                        <div className="flex flex-col justify-center p-8 2xl:p-6 4xl:p-8">

                            <div className="w-full max-w-md mx-auto">

                                <h2 className="text-3xl font-bold text-center mb-2">
                                    Login
                                </h2>

                                <p className="text-center text-slate-500 mb-8">
                                    Sign in to access your account
                                </p>


                                <form onSubmit={handleSubmit} className="space-y-5">

                                    {/* Username */}
                                    <div>
                                        <label
                                            htmlFor="username"
                                            className="block mb-2 font-medium"
                                        >
                                            Username
                                        </label>

                                        <input
                                            id="username"
                                            type="text"
                                            name="username"
                                            placeholder="Enter Username"
                                            value={formData.username}
                                            onChange={handleChange}
                                            className="px-4 py-3 border border-slate-300 rounded-lg w-full outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-500"
                                        />

                                    </div>


                                    {/* Password */}
                                    <div>

                                        <label
                                            htmlFor="password"
                                            className="block mb-2 font-medium"
                                        >
                                            Password
                                        </label>

                                        <input
                                            id="password"
                                            type="password"
                                            name="password"
                                            placeholder="Enter Password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className="px-4 py-3 border border-slate-300 rounded-lg w-full outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-500"
                                        />

                                    </div>


                                    {/* Login Button */}
                                    <div className="pt-3">

                                        <button
                                            type="submit"
                                            className="w-full px-4 py-3 rounded-lg bg-[#1e293b] hover:bg-[#0f172a] text-white font-semibold transition duration-200"
                                        >
                                            Login
                                        </button>

                                    </div>

                                </form>

                            </div>

                        </div>

                    </div>

                </section>

            </main>

        </div>
    )
}

